import useApi from "@/hooks/useApi";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { TeamsContext } from "../context/TeamsContext";
import { SelectOption, Team } from "@velaro/velaro-component-lib";

export function TeamsProvider(props: { children: React.ReactNode }) {
  const api = useApi();
  const [teams, setTeams] = React.useState<Team[]>([]);

  const fetch = useCallback(async () => {
    try {
      const response = await api.messaging.get("Teams/List");
      const data = await response.json();
      setTeams(Array.isArray(data) ? data : []);
      return data;
    } catch {
      setTeams([]);
    }
  }, [api.messaging]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  function getTeamNameById(teamId: number) {
    return teams?.find((x) => x.id === teamId)?.name || "";
  }

  function getTeamById(teamId: number) {
    return teams?.find((x) => x.id === teamId) || null;
  }

  function getTeamByName(teamName: string) {
    return teams?.find((x) => x.name === teamName) || null;
  }

  const teamOptions = useMemo(() => {
    return teams.map((team) => ({
      label: team.name,
      value: team.id
    })) as SelectOption[];
  }, [teams]);

  return (
    <TeamsContext.Provider
      value={{
        teams: teams,
        teamOptions,
        getTeamNameById,
        getTeamByName,
        setTeams,
        getTeamById
      }}
    >
      {props.children}
    </TeamsContext.Provider>
  );
}
